import React, { createContext, useContext, ReactNode } from 'react';
import { Shift, ShiftLocation } from '../hooks/useShift';

interface ShiftContextType {
  currentShift: Shift | undefined;
  isActive: boolean;
  isPaused: boolean;
  canStartRegistration: boolean;
  // refreshShift: () => void;
}

const ShiftContext = createContext<ShiftContextType | undefined>(undefined);

interface ShiftProviderProps {
  children: ReactNode;
  currentShift: Shift | undefined;
  isLoading: boolean;
  // refetch: () => void;
}

export function ShiftProvider({ children, currentShift, isLoading }: ShiftProviderProps) {
  const isActive = !!currentShift;
  const isPaused = currentShift?.status === 'PAUSED';
  const canStartRegistration = isActive && !isPaused;

  // const refreshShift = () => {
  //   refetch();
  // };

  const value: ShiftContextType = {
    currentShift,
    isActive,
    isPaused,
    canStartRegistration,
    // refreshShift,
  };

  return (
    <ShiftContext.Provider value={value}>
      {children}
    </ShiftContext.Provider>
  );
}

export function useShiftContext() {
  const context = useContext(ShiftContext);
  if (context === undefined) {
    throw new Error('useShiftContext must be used within a ShiftProvider');
  }
  return context;
}
